// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"136":"e602e8aa","161":"2dedd554","269":"9bacddf0","333":"99220610","526":"b01c15d1","532":"0e885c21","602":"5c248f69","649":"728be860","743":"5dee1a50","877":"9a82f9f5"}[chunkId] + ".js";
};